module.exports = __webpack_public_path__ + "img/Skills.bead61f6.svg";